export default __webpack_public_path__ + "static/media/gauge_0.8c30410b.svg";